import { render } from "./WagerRewards.vue?vue&type=template&id=ba3ecc32&scoped=true"
import script from "./WagerRewards.vue?vue&type=script&lang=js"
export * from "./WagerRewards.vue?vue&type=script&lang=js"

import "./WagerRewards.vue?vue&type=style&index=0&id=ba3ecc32&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ba3ecc32"]])

export default __exports__